module.exports = __webpack_public_path__ + "static/media/10.23b1d69f.svg";